const Bookmark = () => {
  return (
    <div className="bookmark options">
      <div>
        <h2>Bookmark in one click</h2>
        <p>Organize your bookmarks however you like. Our simple drag-and-drop interface gives you complete control over how you manage your favourite sites.</p>
        <button>More Info</button>
      </div>
    </div>
  )
}

export default Bookmark